<template>
  <div
    class="infobar"
    :style="infoBar"
  >
    <div class="pull-left">
      {{ infoBarMessage }}
    </div>
    <div class="pull-right">
      <button
        class="btn btn-xs btn-default reset-button"
        @click="resetScreenWindow()"
      >
        Reset screen window
      </button>
      <button
        class="btn btn-xs btn-default reset-button"
        @click="resetScreenPc()"
      >
        Reset screen PC
      </button>
    </div>
    <div class="pull-right">
      {{ bookieName }} <span v-if="bookieName">|</span> {{ screenName }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBar',
  computed: {
    infoBarMessage() {
      return this.$store.state.infoBarMessage;
    },
    infoBarClassName() {
      return this.$store.state.infoBarClassName;
    },
    bookieName() {
      return this.$store.state.bookieName;
    },
    screenName() {
      return this.$store.state.screenName;
    },
    infoBar() {
      return this.$store.getters.infoBar;
    }
  },
  methods: {
    resetScreenWindow(){
      sessionStorage.removeItem('screenName');

      this.$store.commit('resetScreen');

      window.location.href = '/';
    },
    resetScreenPc() {
      localStorage.removeItem('bookieId');
      sessionStorage.removeItem('screenName');

      this.$store.commit('resetScreen');
      window.location.href = '/';
    }
  }
};
</script>

<style>
.infobar{
  position: fixed;
  bottom: 0;
  height: 30px;
  width: 100%;
  line-height: 30px;
  padding-left: 10px;
  padding-right: 10px;
}
.infobar-error{
  background-color: red;
}
.reset-button {
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// InfoBar.vue?7f271988